import { useEffect, useState } from 'preact/hooks'

/**
 *  @typedef {import("../types/use-fetch-types.ts").useFetchPropType} useFetchPropType
 *  @typedef {import("../types/use-fetch-types.ts").useFetchConfig} useFetchConfig
 *  @typedef {import("../types/use-fetch-types.ts").FetchState} FetchState
 */

/**
 *
 * @param {useFetchPropType} props
 * @return {{config:useFetchConfig, handleRefetch: () => void }}
 */
export const useFetch = (props) => {
  /**
   * @type {[useFetchConfig, Dispatch<StateUpdater<useFetchConfig>>]}
   */
  const [config, setConfig] = useState({
    ...props,
    data: {},
    state: 'INIT'
  })
  /**
   * @type {[number, Dispatch<StateUpdater<number>>]}
   */
  const [refetchConfig, setRefetchConfig] = useState(0)
  const handleRefetch = () => setRefetchConfig((n) => (n += 1))
  /**
   *
   * @param {FetchState} state
   */
  const handleUpdateState = (state) => setConfig((c) => ({ ...c, state }))
  useEffect(() => {
    if (!config?.fetchOnRender) {
      setConfig((c) => ({ ...c, fetchOnRender: true }))
      return
    }
    handleUpdateState('FETCHING')
    fetch(config.url, config?.options)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Error')
        }
        return response.json()
      })
      .then((data) => {
        setConfig((c) => ({ ...c, data }))
        handleUpdateState('SUCCESS')
      })
      .catch((err) => {
        console.error(err, 'wer')
        handleUpdateState('ERROR')
      })
  }, [refetchConfig])

  return { config, handleRefetch }
}
